export default "__VITE_ASSET__Cj4jqJp$__"